module.exports = __webpack_public_path__ + "static/media/attachment.8558fe95.svg";